import axios from 'axios';
import BaseApi from './base';
import {
    GET_TICKETS,
    GET_TICKET_CATEGORIES,
    SAVE_TICKET,
    GET_TICKET_BY_ID,
    ADD_MESSAGE,
    SET_TICKET_STATUS
} from '@/constants/api';

export default class extends BaseApi {
    static get() {
        return axios.get(GET_TICKETS);
    }

    static getById(id) {
        return axios.get(GET_TICKET_BY_ID + '/' + id);
    }

    static getCategories() {
        return axios.get(GET_TICKET_CATEGORIES);
    }

    static save(data) {
        return axios.post(SAVE_TICKET, this.stringify(data));
    }

    static setStatus(data) {
        const {
            id,
            status
        } = data;
        return axios.get(SET_TICKET_STATUS + '/' + id, {
            params: {
                status
            }
        });
    }

    static addMessage(data) {
        return axios.post(ADD_MESSAGE, this.stringify(data));
    }
}